import React, { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const NAVY = "#0f172a";
const SLATE = "#475569";
const MUTED = "#64748b";
const BORDER = "#e2e8f0";
const CRIMSON = "#A5122F";
const W = 720;
const REMARK_PLUGINS = [remarkGfm];

const md = {
  h1: ({ node, ...p }) => <h1 style={{ fontSize: 18, color: NAVY, margin: "10px 0 6px" }} {...p} />,
  h2: ({ node, ...p }) => <h2 style={{ fontSize: 14, color: NAVY, margin: "10px 0 5px" }} {...p} />,
  h3: ({ node, ...p }) => <h3 style={{ fontSize: 12.5, color: CRIMSON, margin: "8px 0 4px" }} {...p} />,
  p: ({ node, ...p }) => <p style={{ fontSize: 11, lineHeight: 1.5, color: SLATE, margin: "0 0 6px" }} {...p} />,
  ul: ({ node, ordered, ...p }) => <ul style={{ margin: "0 0 6px", paddingLeft: 18, fontSize: 11, color: SLATE }} {...p} />,
  ol: ({ node, ordered, ...p }) => <ol style={{ margin: "0 0 6px", paddingLeft: 18, fontSize: 11, color: SLATE }} {...p} />,
  li: ({ node, ...p }) => <li style={{ margin: "0 0 3px" }} {...p} />,
  strong: ({ node, ...p }) => <strong style={{ color: NAVY }} {...p} />,
  table: ({ node, ...p }) => <table style={{ borderCollapse: "collapse", fontSize: 10, margin: "0 0 6px" }} {...p} />,
  th: ({ node, ...p }) => <th style={{ border: `1px solid ${BORDER}`, padding: "3px 6px", background: "#f8fafc", textAlign: "left" }} {...p} />,
  td: ({ node, ...p }) => <td style={{ border: `1px solid ${BORDER}`, padding: "3px 6px", color: SLATE }} {...p} />,
};

const ChatTranscriptPrint = forwardRef(function ChatTranscriptPrint({ messages }, ref) {
  const list = (messages || []).filter((m) => m.answer);

  return (
    <div aria-hidden="true" style={{ position: "absolute", width: 0, height: 0, overflow: "hidden", left: 0, top: 0 }}>
      <div ref={ref} style={{ width: W, background: "#fff", color: NAVY, fontFamily: "Arial, Helvetica, sans-serif", padding: "0 32px 32px" }}>
        <div style={{ borderBottom: `3px solid ${CRIMSON}`, paddingBottom: 12, marginBottom: 16 }}>
          <h1 style={{ margin: 0, fontSize: 22 }}>SalesTap — Analyst Q&amp;A Transcript</h1>
          <p style={{ margin: "4px 0 0", fontSize: 12, color: MUTED }}>
            {list.length} question{list.length === 1 ? "" : "s"} · generated {new Date().toLocaleString()}
          </p>
        </div>

        {list.length === 0 ? (
          <p style={{ fontSize: 11.5, color: MUTED }}>No questions asked yet.</p>
        ) : (
          list.map((m, i) => (
            <div key={m.id} style={{ marginBottom: 16, pageBreakInside: "avoid" }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: NAVY, marginBottom: 4 }}>
                Q{i + 1}. {m.question}
              </div>
              <div style={{ borderLeft: `3px solid ${CRIMSON}`, paddingLeft: 10 }}>
                <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={md}>{m.answer}</ReactMarkdown>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
});

export default ChatTranscriptPrint;
